// https://github.com/adobe/react-spectrum/blob/1e2b7f280a04ead83e21b27fa580eb189e5f4186/packages/%40react-aria/focus/src/FocusScope.tsx
const focusableElements = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[contenteditable]",
]

export const FOCUSABLE_ELEMENT_SELECTOR =
  focusableElements.join(":not([hidden]),") + ",[tabindex]:not([hidden])"

focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])')
export const TABBABLE_ELEMENT_SELECTOR = focusableElements.join(
  ':not([hidden]):not([tabindex="-1"]),',
)

export function getFirstFocusableElement<T extends HTMLElement = HTMLElement>(
  el: T,
) {
  return [...el.querySelectorAll(TABBABLE_ELEMENT_SELECTOR)][0] as
    | HTMLElement
    | undefined
    | null
}

export function tryFocusFirstChild<T extends HTMLElement = HTMLElement>(
  parent?: T,
) {
  if (parent == null) return
  const el = getFirstFocusableElement(parent)
  if (!el) return
  try {
    el.focus()
  } catch (err) {
    // ignore
  }
}
